// extracted by mini-css-extract-plugin
export default {"root":"AddRefereeCard_root__EZIjE","card":"AddRefereeCard_card__vuifq","icon":"AddRefereeCard_icon__jRKvr"};